import { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const VerifiedListingDetails: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}> X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Item Details</h1>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Grade</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Color</th>
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Packaginng</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.grade || 'N/A'}
                                        </span>
                                    </td>
                                    <td className="ps-4">
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.orderDetail[0]?.items[0]?.color || 'N/A'}
                                        </span>
                                    </td>

                                    <td>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {user.packagingType || 'N/A'}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="table-responsive mt-8">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Verification Information</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex gap-4 flex-wrap">
                                            {user.images?.filter(img => img.docType === 'VERIFIED_DOC').map((img, index) => (
                                                <div key={index} className="text-center">
                                                    <img
                                                        src={img.docUrl}
                                                        alt={`Verification Document ${index + 1}`}
                                                        className="h-150px w-150px object-cover rounded cursor-pointer"
                                                        style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                        onClick={() => window.open(img.docUrl, '_blank')}
                                                        onError={(e) => {
                                                            e.currentTarget.src = '/media/avatars/blank.png';
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                            {!user.images?.some(img => img.docType === 'VERIFIED_DOC') && (
                                                <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>







                    <div className="table-responsive mt-8">
                        <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                            <thead>
                                <tr className="fw-bold text-muted bg-light">
                                    <th className="min-w-100px ps-4"
                                        style={{
                                            backgroundColor: '#BFD7ED',
                                            color: 'black',
                                            fontWeight: 'bold'
                                        }}
                                    >Listed Images</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex gap-4 flex-wrap">
                                            {user.images?.filter(img => ['MATERIAL_DOC', 'SALE_DOC'].includes(img.docType)).map((img, index) => (
                                                <div key={index} className="text-center">
                                                    <img
                                                        src={img.docUrl}
                                                        alt={`Document ${img.docType} ${index + 1}`}
                                                        className="h-150px w-150px object-cover rounded cursor-pointer"
                                                        style={{ maxWidth: '300px', border: '1px solid #eee' }}
                                                        onClick={() => window.open(img.docUrl, '_blank')}
                                                        onError={(e) => {
                                                            e.currentTarget.src = '/media/avatars/blank.png';
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                            {!user.images?.some(img => ['MATERIAL_DOC', 'SALE_DOC'].includes(img.docType)) && (
                                                <span className="text-dark fw-semibold d-block fs-6">N/A</span>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};